import { FixedExpenseStatus, mapRecurrenceTypeFromBackend, roundMoney } from '../../../../utils';

export type ProgressLevel = 'good' | 'warning' | 'over';

// Same thresholds as budget progress bars
export const getProgressLevel = (percent: number): ProgressLevel =>
  percent > 110 ? 'over' : percent > 100 ? 'warning' : 'good';

export const getPercent = (value: number, total: number): number =>
  total > 0 ? (value / total) * 100 : value > 0 ? 100 : 0;

export const getRecurrenceLabel = (
  recurrenceType: string | null | undefined,
  dayOfMonth?: number | null,
  paymentsCount = 1
): string => {
  if (!recurrenceType) return '';

  switch (mapRecurrenceTypeFromBackend(recurrenceType)) {
    case '1':
      return paymentsCount > 1 ? `щотижня × ${paymentsCount}` : 'щотижня';
    case '3':
      return 'щороку';
    default:
      return dayOfMonth ? `щомісяця, ${dayOfMonth}-го` : 'щомісяця';
  }
};

export const FIXED_STATUS_LABELS: Record<FixedExpenseStatus, string> = {
  paid: 'Сплачено',
  partial: 'Частково',
  pending: 'Очікує',
  overdue: 'Прострочено'
};

export const parseAmountInput = (value: string): number => {
  const parsed = parseFloat(value.replace(',', '.'));
  return isNaN(parsed) ? 0 : parsed;
};

export const toAmountInput = (amount: number): string => (amount > 0 ? String(roundMoney(amount)) : '');
